import React, { Component } from "react";
import Message from "./Message";
import MessageInput from "./MessageInput";
import axios from "axios";
import socketIOClient from "socket.io-client";
import ScrollToBottom from "react-scroll-to-bottom";
import BtnClose from "./BtnClose";
import Socials from "./Socials";
import Loader from "./Loader";
import ChatButton from "./ChatButton";
import Rating from "react-rating";
import starFull from "../assets/images/star_full.png";
import Star from "../assets/images/star.png";
import ReactHtmlParser from "react-html-parser";
import LinkMessage from "./LinkMessage";

function transform(node) {
  if (node.type === "tag" && node.name === "link") {
    return (
      <LinkMessage
        title={node.attribs.title}
        onSubmitLinkResponse={(message) => window.zChatbotSendAsUser(message)}
      />
    );
  }
}

const options = {
  decodeEntities: true,
  transform,
};

class Chat extends Component {
  constructor(props) {
    super(props);
    window.zChatbotSendAsUser = (message) => this.sendAsUser(message);

    this.state = {
      connected: false,
      started: false,
      closed: true,
      error: "",
      context:
        JSON.parse(sessionStorage.getItem("cbContext")) != null
          ? JSON.parse(sessionStorage.getItem("cbContext"))
          : {},
      showRating: false,
      userRating: 0,
      botLoading: false,
      messages:
        JSON.parse(sessionStorage.getItem("chatAppMessages")) != null &&
        JSON.parse(sessionStorage.getItem("chatAppMessages")).length > 0
          ? JSON.parse(sessionStorage.getItem("chatAppMessages"))
          : [],
    };
  }

  socket;

  componentDidMount() {
    if (sessionStorage.getItem("chatAppClosed"))
      setTimeout(() => {
        this.openChat();
      }, 500);

    if (Object.entries(this.state.context).length === 0) this.Connect();
    else this.connectToSocket(true);

    setInterval(() => {
      document.querySelector(".chatToggle").classList.toggle("shake");
    }, 10000);

    console.log(JSON.parse(sessionStorage.getItem("cbContext")));
    // this.setupBeforeUnloadListener();
  }

  // setupBeforeUnloadListener = () => {
  //   window.addEventListener("beforeunload", (ev) => {
  //     sessionStorage.removeItem('chatAppClosed')
  //   });
  // };

  Connect = () => {
    axios({
      method: "post",
      url: this.props.API_URL + "initChat",
      data: {
        token: this.props.TOKEN, // the static token
        usecase: this.props.USECASE, // DEMO => for develmement usecase
      },
    })
      .then((response) => {
        this.setState({
          context: response.data.context,
          connected: true,
        });
        sessionStorage.setItem("cbContext", JSON.stringify(this.state.context));
        console.log(this.state.context);
        console.log(JSON.parse(sessionStorage.getItem("cbContext")));
        console.log(
          JSON.stringify(this.state.context) ===
            sessionStorage.getItem("cbContext")
        );
        console.log("Chat initialized");
        this.connectToSocket(false);
      })
      .catch((error) => {
        this.setState({
          error: error,
        });
        this.appendMessage(error, "fromBot");
      });
  };

  connectToSocket = (loadMessagesFromSession) => {
    this.socket = socketIOClient.connect(this.props.API_URL, {
      query: this.state.context,
    });
    this.socket.on("bot_response", (data) => {
      console.log("connected to socket");
      this.setState({
        context: data.context,
        started: true,
      });

      sessionStorage.setItem("cbContext", JSON.stringify(this.state.context));
      console.log(this.state.context);
      console.log(JSON.parse(sessionStorage.getItem("cbContext")));
      console.log(
        JSON.stringify(this.state.context) ===
          sessionStorage.getItem("cbContext")
      );

      this.sendAsBot(data.response);
    });
  };

  sendAsBot = (response) => {
    this.appendMessage(response, "fromBot");
  };

  sendAsUser = (message) => {
    this.appendMessage(message, "fromUser");

    this.socket.emit("connect", { context: this.state.context }, function (d) {
      console.log("User connected");
    });
    console.log(this.state.context);
    this.socket.emit(
      "get_response",
      {
        input: message,
        context: this.state.context,
      },
      (data) => console.log(data)
    );
  };

  sendRating = (rating_value) => {
    if (this.state.userRating > 0) return;

    this.setState({
      userRating: rating_value,
    });

    this.socket.emit("connect", { context: this.state.context }, function (d) {
      console.log("Rating connected");
    });

    this.socket.emit(
      "get_response",
      {
        client_satisfaction: rating_value,
        context: this.state.context,
      },
      (data) => console.log(data)
    );

    // setTimeout(() => {
    this.setState({
      showRating: false,
    });
    // }, 500);
  };

  appendMessage = (message, from) => {
    this.setState({
      botLoading: from === "fromUser" ? true : false,
    });

    this.setState((state) => ({
      messages: [
        ...state.messages,
        {
          from: from,
          message: message,
          images:
            this.state.context.images && from === "fromBot"
              ? this.state.context.images
              : [],
          videos:
            this.state.context.videos && from === "fromBot"
              ? this.state.context.videos
              : [],
          buttons:
            this.state.context.buttons && from === "fromBot"
              ? this.state.context.buttons
              : [],
        },
      ],
    }));

    // if (!this.state.closed)
    //   document.body.classList.add("zChatOpened");

    if (
      this.state.context.hasOwnProperty("satisfaction") &&
      this.state.userRating === 0
    )
      this.showRating();

    document.querySelector(
      ".scrollHeightChild"
    ).scrollTop = document.querySelector(".scrollHeightChild").scrollHeight;

    // console.log(this.state.context);
    // console.log(this.state.messages);
    sessionStorage.setItem(
      "chatAppMessages",
      JSON.stringify(this.state.messages)
    );

    if (from === "fromUser") {
      sessionStorage.setItem(
        "lastUserMessageIndex",
        this.state.messages.length
      );
      let paqData = ["trackEvent", "Chatbot", "Request", message, null];
      window._paq.push(paqData);
    }

    if (from === "fromBot" && sessionStorage.getItem("lastUserMessageIndex")) {
      var trackResponseTimer = setTimeout(() => {
        this.trackResponse();
      }, 1000);
      if (trackResponseTimer) clearTimeout(trackResponseTimer);
    }
  };

  closeChat = () => {
    this.setState({
      closed: true,
    });
    document.body.classList.remove("zChatOpened");
    sessionStorage.removeItem("chatAppClosed");
    window._paq.push(["trackEvent", "Chatbot", "Results", "Statut fenêtre", 0]);
  };

  openChat = () => {
    this.setState({
      closed: false,
    });
    document.body.classList.add("zChatOpened");
    sessionStorage.setItem("chatAppClosed", 0);
    window._paq.push(["trackEvent", "Chatbot", "Results", "Statut fenêtre", 1]);
  };

  showRating = () => {
    this.setState({
      showRating: true,
    });
  };

  handleScroll = (event) => {
    if (event.deltaY > 0) {
      this.decreaseValue();
    } else {
      this.increaseValue();
    }
  };

  enableScroll = () => {
    document.removeEventListener("wheel", this.preventDefault, false);
  };

  disableScroll = () => {
    document.addEventListener("wheel", this.preventDefault, {
      passive: false,
    });
  };

  preventDefault(e) {
    e = e || window.event;
    if (e.preventDefault) {
      e.preventDefault();
    }
    e.returnValue = false;
  }

  trackResponse = () => {
    let messageObject = this.state.messages[
      sessionStorage.getItem("lastUserMessageIndex")
    ];
    sessionStorage.setItem("lastUserMessageValue", messageObject.message);
    let paqData = [
      "trackEvent",
      "Chatbot",
      "Results",
      messageObject.message,
      this.getBotResponseScore(),
    ];
    window._paq.push(paqData);
    // console.log(paqData);
  };

  getBotResponseScore = () => {
    let score = 0;
    let lastBotMessagesCount =
      this.state.messages.length -
      1 -
      sessionStorage.getItem("lastUserMessageIndex");

    let lastBotMessagesValue = this.state.messages[
      this.state.messages.length - 1
    ].message;

    let nonCompris = [
      "Désolé je n'ai toujours pas compris",
      "Je n'ai pas bien compris votre demande, pouvez-vous me la préciser en quelques mots ?",
    ];

    // console.log(lastBotMessagesValue);
    // console.log(lastBotMessagesCount);

    if (
      lastBotMessagesCount === 1 &&
      !nonCompris.includes(lastBotMessagesValue)
    ) {
      score = 1;
    } else {
      score = lastBotMessagesCount;
    }

    return score;
  };

  render() {
    return (
      <div
        id="appContainer"
        className={[
          this.state.messages.length > 1 ? "chatStarted" : "chatNotStarted",
          this.state.closed === true ? "closed" : "",
        ].join(" ")}
      >
        <div id="app" className="d-flex flex-column justify-content-between">
          <BtnClose onCloseChat={this.closeChat} />
          <div id="chatAppTitle">{this.props.BOX_TITLE}</div>
          <div id="messages">
            <ScrollToBottom
              className="scrollHeightAuto"
              scrollViewClassName="scrollHeightChild"
            >
              {this.state.messages.map((message, index) => (
                <Message
                  key={index}
                  from={message.from}
                  message={message.message}
                  buttons={message.buttons}
                  images={message.images}
                  videos={message.videos}
                  onSubmitButtonResponse={(message) => this.sendAsUser(message)}
                />
              ))}

              {this.state.botLoading && <Loader />}
            </ScrollToBottom>
          </div>

          <div
            id="zRatingContainer"
            className={this.state.showRating ? "ratingActive" : ""}
          >
            <div id="zRating">
              <p>
                Comment évaluez-vous la
                <br />
                qualité de notre échange ?
              </p>
              <Rating
                emptySymbol={<img src={Star} className="icon" alt="" />}
                fullSymbol={<img src={starFull} className="icon" alt="" />}
                fractions={2}
                onChange={(rate) => this.sendRating(rate)}
                readonly={this.state.userRating > 0 ? true : false}
                initialRating={this.state.userRating}
              />
            </div>
            {this.state.showRating && (
              <div id="zSocial">
                <Socials icons={this.state.context.satisfaction.social} />
              </div>
            )}
          </div>

          <MessageInput
            message=""
            placeholder={this.props.INPUT_PLACEHOLDER}
            onSubmitMessage={(message) => this.sendAsUser(message)}
          />
        </div>
        <div id="defaultContent">
          <div
            className="text"
            dangerouslySetInnerHTML={{ __html: this.props.TEXT_INTRO }}
          ></div>
          <div className="slide">
            <div>{this.props.TEXT_SLIDE_1}</div>
            <div id="onBoarding">
              {ReactHtmlParser(this.props.TEXT_SHORTCODE, options)}
            </div>
          </div>
        </div>
        <ChatButton onOpenChat={this.openChat} />
      </div>
    );
  }
}

export default Chat;
